<template>
  <form-dialog
    ref="formDialog"
    class="v-problem-report"
    :apply-button-text="$t('Generate and send')"
    :errors="errors"
    :model="form"
    :pending="pending"
    :rules="rules"
    :submit="onSubmit"
    :title="$t('Send problem report')"
    visible
    width-size="medium"
    @close="onClose"
  >
    <div class="mx-24 mt-24 mb-8">
      {{ $t('A problem report contains data about configuration of all cluster services, their usage statistics, logs (including debug), details on node hardware (IP/MAC addresses, HWIDs/names, S.M.A.R.T. statuses, etc.), as well as details on software (OS and other data). A report may also contain kernel panic and segmentation fault dumps.') }}
    </div>
    <div class="mx-24 mb-16">
      {{ $t('After a problem report is generated, contact {brand} Support and mention the report ID in the support ticket.', { brand }) }}
    </div>
    <el-divider />
    <div class="mx-24 mt-24">
      <el-form-item
        :error="errors.contact_email"
        prop="contact_email"
      >
        <el-input
          v-model="form.contact_email"
          :label="$t('Contact email')"
        />
      </el-form-item>
      <el-form-item prop="problem_description">
        <template #label>
          {{ $t('Describe the issue you are experiencing (optional)') }}
        </template>
        <el-input
          v-model="form.problem_description"
          :rows="3"
          type="textarea"
        />
      </el-form-item>
    </div>
  </form-dialog>
</template>

<script>
  import ValidationError from '@/common/utils/errors/ValidationError';
  import FormDialog from '@/common/shared/FormDialog.vue';
  import createStore from '@/common/store/createStore';
  import { contactEmailRules } from '@/common/validation/authRules';
  import { mapState } from 'pinia';
  import useThemeStore from '@/common/store/pinia/theme';

  export default {
    name: 'ProblemReport',
    components: { FormDialog },
    data() {
      return {
        pending: false,
        errors: {},
        form: {
          contact_email: '',
          problem_description: ''
        }
      };
    },
    created() {
      createStore(['nodes']);
    },
    computed: {
      ...mapState(useThemeStore, ['themeData']),
      rules() {
        return {
          contact_email: contactEmailRules()
        };
      },
      brand() {
        return this.themeData.brandName;
      }
    },
    methods: {
      onClose() {
        if (!this.pending) {
          this.$emit('close');
        }
      },
      onSubmit() {
        this.errors = {};
        this.pending = true;

        return this.$store.dispatch('problemReport/REPORT_PROBLEM', this.form)
          .then(() => {
            this.pending = false;
            this.$refs.formDialog.resetFields();
            this.onClose();
          })
          .catch((err) => {
            this.pending = false;
            if (err instanceof ValidationError && err.fields) {
              this.errors = err.fields;
            }
            throw err;
          });
      }
    }
  };
</script>

<style scoped lang="scss">
  .title {
    margin-bottom: 8px;
    font-weight: $av-font-weight-bold;
  }

  .error {
    padding: 8px 24px;
    border-top: 1px solid $av-brand-light;

    .icon-error {
      color: $av-fixed-danger;
    }
  }

  .highlight {
    font-weight: $av-font-weight-bold;
  }
</style>
